import { Route } from '@angular/router';
import { crmLandingRoute } from './crm-route.helpers';

const CAMPAIGNS_CRUMB = { id: 'campaigns', label: 'Campañas' };

export const CRM_CAMPAIGNS_ROUTES: Route[] = [
  crmLandingRoute({
    path: 'campaigns/campaigns/campaigns',
    moduleId: 'campaigns',
    activeMenubarId: 'camp-list',
    title: 'Campañas',
    breadcrumbs: [CAMPAIGNS_CRUMB, { id: 'campaign-list', label: 'Campañas' }],
    loadComponent: () =>
      import('../pages/campaigns/campaigns/campaigns/campaigns.component').then(
        (m) => m.CampaignsListComponent,
      ),
  }),
  crmLandingRoute({
    path: 'campaigns/reactivations/reactivations',
    moduleId: 'campaigns',
    activeMenubarId: 'camp-reactivations',
    title: 'Reactivaciones',
    breadcrumbs: [
      CAMPAIGNS_CRUMB,
      { id: 'reactivations', label: 'Reactivaciones' },
    ],
    loadComponent: () =>
      import(
        '../pages/campaigns/reactivations/reactivations/reactivations.component'
      ).then((m) => m.CampaignReactivationsComponent),
  }),
  crmLandingRoute({
    path: 'campaigns/catalogs/types',
    moduleId: 'campaigns',
    activeMenubarId: 'camp-cat-types',
    title: 'Tipos de campaña',
    breadcrumbs: [
      CAMPAIGNS_CRUMB,
      { id: 'catalogs', label: 'Catálogos' },
      { id: 'types', label: 'Tipos de campaña' },
    ],
    loadComponent: () =>
      import('../pages/campaigns/catalogs/types/campaign-types.component').then(
        (m) => m.CampaignTypesComponent,
      ),
  }),
  crmLandingRoute({
    path: 'campaigns/reports/campaigns',
    moduleId: 'campaigns',
    activeMenubarId: 'camp-rep-campaigns',
    title: 'Campañas',
    breadcrumbs: [
      CAMPAIGNS_CRUMB,
      { id: 'reports', label: 'Reportes' },
      { id: 'campaigns-report', label: 'Campañas' },
    ],
    loadComponent: () =>
      import(
        '../pages/campaigns/reports/campaigns/campaigns-report.component'
      ).then((m) => m.CampaignsReportComponent),
  }),
];
